$(document).ready(function () {
    //modal

    $('.modal-marcas-1_close').on('click', function () {
        $('.overlay, #marcas-1').fadeOut('slow'); //при нажатии на крестик закрываю блок
    });
    $('.modal-marcas-1_close').on('click', function () {
        $('.overlay, #marcas-2').fadeOut('slow'); //при нажатии на крестик закрываю блок
    });
    $('.modal-marcas-1_close').on('click', function () {
        $('.overlay, #marcas-3').fadeOut('slow'); //при нажатии на крестик закрываю блок
    });
});